import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

const TIMETABLE_NOT_DELETABLE_ERROR_NAME = 'TimetableNotDeletableError';

/** Marker for 400/404 responses, whose `message` is written for the end user and shown verbatim. */
export const isTimetableNotDeletableError = (err: unknown): err is Error =>
  err instanceof Error && err.name === TIMETABLE_NOT_DELETABLE_ERROR_NAME;

export const deleteTimetable = async (timetableId: string, dryRun?: boolean): Promise<void> => {
  const query = dryRun ? '?dryRun=true' : '';
  const res = await fetch(`${API_URL}/timetables/${timetableId}${query}`, {
    method: 'DELETE',
  });

  if (res.status === Status.BAD_REQUEST || res.status === Status.NOT_FOUND) {
    const message = await res
      .json()
      .then((json) => json.message)
      .catch(() => 'Could not delete timetable');
    const error = new Error(message);
    error.name = TIMETABLE_NOT_DELETABLE_ERROR_NAME;
    throw error;
  }

  if (!res.ok) {
    throw new Error('Could not delete timetable');
  }
};

/** Runs every server-side validation and deletes nothing, so blockers surface before we confirm. */
export const canDeleteTimetable = (timetableId: string): Promise<void> => deleteTimetable(timetableId, true);
